import axios from 'axios'

const quotApi = axios.create({
  baseURL: process.env.REACT_APP_QUOTE_API_URL,
})

export default quotApi
